<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Manual Testing</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Manual Testing</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Manual Testing</h3>
                    <p>Manual Testing is a type of software testing in which test cases are executed manually by a
                        tester without using any automated tools. The purpose of Manual Testing is to identify the bugs,
                        issues, and defects in the software application. Manual software testing is the most primitive
                        technique of all testing types and it helps to find critical bugs in the software application.
                    </p>
                    <h3>Goal of Manual Testing</h3>
                    <p>The key concept of manual testing is to ensure that the application is error free and it is
                        working in conformance to the specified functional requirements.

                        Test Suites or cases, are designed during the testing phase and should have 100% test coverage.

                        It also makes sure that reported defects are fixed by developers and re-testing has been
                        performed by testers on the fixed defects.

                        Basically, this testing checks the quality of the system and delivers bug-free product to the
                        customer.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Black Box Testing</li>
                                    <li><i class="flaticon-check"></i> The Problem</li>
                                    <li><i class="flaticon-check"></i> White Box Testing</li>
                                    <li><i class="flaticon-check"></i> Unit Testing</li>
                                    <li><i class="flaticon-check"></i> System Testing</li>
                                    <li><i class="flaticon-check"></i> Integration Testing</li>
                                    <li><i class="flaticon-check"></i> Acceptance Testing</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="text-result">
                        <h3>How to perform Manual Testing</h3>
                        <p>Read and understand the software project documentation/guides. Also, study the Application
                            Under Test (AUT) if
                            available.
                            Draft Test cases that cover all the requirements mentioned in the documentation.
                            Review and baseline the test cases with Team Lead, Client (as applicable)
                            Execute the test cases on the AUT
                            Report bugs.
                            Once bugs are fixed, again execute the failing test cases to verify they pass.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Unit Test Cases</a></li>
                        <li><a routerLink="/technology-expertise">Bug Reports</a></li>
                        <li><a routerLink="/technology-expertise">Selenium</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">JMeter</a></li>
                        <li><a routerLink="/technology-expertise">Jira</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/automation-testing-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/automation-testing-services">Automation Testing</a>
                        </h3>
                        <span>Using Tools</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/api-testing-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/api-testing-services">API Testing</a>
                        </h3>
                        <span>Using Tool</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/database-testing-services">
                            <img src="assets/img/services/services-10.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/database-testing-services">Database Testing</a>
                        </h3>
                        <span>Using Queries</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->